import React from "react";
import Card from "../Card/Card";
import { Container } from "../Container/Container";
import { H2 } from "../../styles/Typography";
import { CardsGrid, CardWide } from "./StatsPanel.styles";

/** Одна карточка панели статистики */
export interface StatItem {
  /** идентификатор, с которым карточка публикует событие нажатия */
  id: string;
  icon?: React.ReactNode;
  header: string;
  title: string;
  /** карточка занимает два места по горизонтали вместо одного */
  wide?: boolean;
}

interface StatsPanelProps {
  items: StatItem[];
  title?: string;
  /** id подсвеченной карточки */
  selectedId?: string | null;
  /** подписка на нажатие карточки; без неё карточки некликабельны */
  onSelect?: (id: string) => void;
}

/**
 * Панель статистики: показывает карточки и публикует нажатия по ним.
 * Что означает нажатие и на что оно влияет — панель не знает,
 * это решает подписчик.
 */
const StatsPanel: React.FC<StatsPanelProps> = ({
  items,
  title = "Статистика",
  selectedId,
  onSelect,
}) => {
  return (
    <Container>
      <H2>{title}</H2>
      <CardsGrid>
        {items.map((item) => {
          const card = (
            <Card
              icon={item.icon}
              header={item.header}
              title={item.title}
              onClick={onSelect ? () => onSelect(item.id) : undefined}
              active={selectedId === item.id}
            />
          );

          return item.wide ? (
            <CardWide key={item.id}>{card}</CardWide>
          ) : (
            <React.Fragment key={item.id}>{card}</React.Fragment>
          );
        })}
      </CardsGrid>
    </Container>
  );
};

export default StatsPanel;
